var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-row',[_c('lg-finder',{ref:"finder",attrs:{"id":this.id,"fields":_vm.fields,"title":"Busca tipo estado conservação","url":"/api/tipo-estado-conservacao","filterBy":"nome","othersFilters":_vm.othersFilters,"filtrarSituacao":""},on:{"onSelect":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }